import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ParametriStampa } from 'src/app/models/parametri-stampa';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ParametriStampaService {
  private http = inject(HttpClient);


  parStampaDpiUrl = environment.ildatoArticoliDpi + 'api/parametristampadpi';
  parStampaDotazioniUrl = environment.ildatoArticoliDpi + 'api/parametristampadotazioni';

  get(tipo: string): Observable<ParametriStampa> {
    if (tipo=='DPI') {
      return this.http.get<ParametriStampa>(this.parStampaDpiUrl);
    }
    else if (tipo=='DOTAZIONI') {
      return this.http.get<ParametriStampa>(this.parStampaDotazioniUrl);
    }
  }

  insert(values: ParametriStampa, tipo:string): Observable<ParametriStampa> {
    console.log(values);
    if (tipo=='DPI') {
      return this.http.post<ParametriStampa>(this.parStampaDpiUrl, values);
    }
    else if (tipo=='DOTAZIONI') {
      return this.http.post<ParametriStampa>(this.parStampaDotazioniUrl, values);
    }
    
  }

  stampaprova(tipo:string): Observable<Blob> {
    if (tipo=='DPI') {
      return this.http.get(this.parStampaDpiUrl + '/stampaprova/', { responseType: 'blob'});
    }
    else if (tipo=='DOTAZIONI') {
      return this.http.get(this.parStampaDotazioniUrl + '/stampaprova/', { responseType: 'blob'});
    }
    
  } 

}
